module.exports = __webpack_public_path__ + "img/jugems-cloud-electrocution.30682919.jpg";